/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const dataRemovalRequestDataStatusSchema = z.enum([
	'pending',
	'notified',
	'approved',
	'rejected',
	'completed',
	'expired',
])

export type DataRemovalRequestDataStatusSchema = z.infer<typeof dataRemovalRequestDataStatusSchema>
